export default "__VITE_ASSET__CnKP0KAj__"